import { render } from "./MarketingShell.vue?vue&type=template&id=352baf8c&scoped=true"
import script from "./MarketingShell.vue?vue&type=script&lang=js"
export * from "./MarketingShell.vue?vue&type=script&lang=js"

import "./MarketingShell.vue?vue&type=style&index=0&id=352baf8c&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352baf8c"]])

export default __exports__